<template>
	<footer class="footer">
		<section>
			<div class="expertThinkTank_center">
				<div class="expertThinkTank_top">
					<p>友情链接</p>
					<div class="webs">
						<ul class="web_item">
							<li v-for="item in list" :key="item.index">
								<a :href="item.link" :title="item.name" target="_blank">{{
                  item.name
                }}</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="line" />
				<div class="expertThinkTank_bottom">
					<div class="info">
						<ul>
							<li v-for="item in tab" :key="item.id">
								<router-link :to="item.link">{{ item.name }}</router-link>
								<el-divider direction="vertical" v-if="item.id != 8" />
							</li>
						</ul>
						<!--            <div class="copy">-->
						<p class="ftp">
							网站备案/许可证号：滇ICP备19003852号 | 服务热线：400-6811-508 |
							邮箱：dh@dhipr.com
						</p>
						<p>版权信息：Copyright © 2009 - 2015 dhipr. All Rights Reserved</p>
						<!--            </div>-->
					</div>
					<div class="qrCode">
						<img src="../../static/imgs/weixin.png" alt="" />
					</div>
				</div>
			</div>
		</section>
	</footer>
</template>


<script>
	export default {
		data() {
			return {
				tab: [{
						id: 1,
						name: "首页",
						link: "/home"
					},
					{
						id: 2,
						name: "服务内容",
						link: "/classicCases"
					},
					{
						id: 3,
						name: "专家智库",
						link: "/expertThinkTank"
					},
					{
						id: 4,
						name: "服务案例",
						link: "/serviceCase"
					},
					{
						id: 5,
						name: "资讯中心",
						link: "/information"
					},
					{
						id: 6,
						name: "关于鼎宏",
						link: "/regardDH"
					},
					{
						id: 7,
						name: "加入鼎宏",
						link: "/joinDH"
					},
					{
						id: 8,
						name: "联系方式",
						link: "/concatUs"
					},
				],
				list: [{
						name: "国家知识产权局",
						link: "https://www.cnipa.gov.cn/"
					},
					{
						name: "中华商标协会",
						link: "http://www.cta.org.cn/"
					},
					{
						name: "中国专利保护协会",
						link: "http://www.ppac.org.cn/"
					},
					{
						name: "北京市知识产权局",
						link: "http://zscqj.beijing.gov.cn/"
					},
					{
						name: "四川省市场监督管理局（省知识产权局、省食品安全办）",
						link: "http://scjgj.sc.gov.cn/scjgj/index.shtml",
					},
					{
						name: "贵州省市场监督管理局（知识产权局）",
						link: "http://amr.guizhou.gov.cn/",
					},
					{
						name: "陕西省知识产权局",
						link: "http://snipa.shaanxi.gov.cn/"
					},
					{
						name: "重庆市知识产权局",
						link: "http://zscqj.cq.gov.cn/"
					},
					{
						name: "云南省知识产权局",
						link: "http://amr.yn.gov.cn/zscqj/"
					},
					{
						name: "河南省知识产权局",
						link: "http://zjxx.hnpatent.gov.cn/"
					},
				],
			};
		},
		mounted() {},
	};
</script>

<style lang="scss" scoped>
	@import "../assets/style/index.scss";

	.footer {
		// width: 70vw;
		background: #f7f7f7 !important;
	}

	.expertThinkTank_centerLeft {
		div {
			color: rgb(91, 48, 21);
			margin-top: 14px;
			font-size: 18px;
		}
	}

	.erweimaDiv {
		display: flex;
		margin-left: 20px;

		div {
			text-align: center;
			font-size: 14px;
		}

		img {
			width: 100px;
			height: 100px;
		}
	}

	.expertThinkTank_center {
		justify-content: center;
		font-size: 14px;
		flex-wrap: wrap;

		.expertThinkTank_top {
			flex-wrap: wrap;
			margin: 0 auto;

			p {
				color: #333;
				margin: auto 5px;
			}

			.webs {
				max-width: 1200px;
				height: auto;
				margin: auto 5px;

				.web_item {
					display: flex;
					justify-content: left;
					align-items: center;
					flex-wrap: wrap;

					li {
						//width: 12vw;
						width: calc(calc(100% / 5) - 0.5rem);
						height: 1.7rem;
						padding: 0.5rem 0;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
						overflow: hidden;

						a {
							color: #999;
							overflow: hidden;
							cursor: pointer;
						}

						a:hover {
							color: #000;
						}
					}

					li:first-child {
						margin: 0;
					}
				}
			}
		}

		.line {
			width: 100%;
			height: 1px;
			background: #dedede;
			margin: 2rem 0;
		}

		.expertThinkTank_bottom {
			width: 100%;
			display: flex;
			justify-content: space-between;
			flex-wrap: nowrap;
			margin: auto 5px;

			.info {

				//display: flex;
				//justify-content: flex-start;
				//align-items: center;
				//flex-wrap: wrap;
				ul {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					flex-wrap: nowrap;

					li {
						width: auto;

						a {
							color: #333;
						}

						a:hover {
							color: #999;
						}

						.el-divider {
							background-color: #bebebe !important;
							margin: 0 0.5rem !important;
						}
					}
				}

				p {
					color: #999;
				}

				.ftp {
					margin: 1rem 0;
				}
			}

			@media screen and(max-width: 500px) {
				.info {
					ul {
						display: flex;
						flex-wrap: wrap;
					}
				}
			}
		}

		@media screen and(max-width: 500px) {
			.expertThinkTank_bottom {
				width: 95vw;
			}
		}
	}


	.footerCenter {
		width: 30vw;

		.footerCenterItem {
			display: flex;
			justify-content: space-around;
			margin-bottom: 20px;

			.title {
				font-weight: 600;
				color: rgb(91, 48, 21);
				font-size: 16px;
			}

			.item {
				color: rgb(91, 48, 21);
				font-size: 14px;
				cursor: pointer;
			}

			.item:hover {
				font-weight: 600;
			}
		}
	}

	.expertThinkTank_center_content {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin: 20px 0;

		.expertThinkTank_centerItem {
			position: relative;
			width: 360px;
			// height: 330px;
			// background: crimson;
			margin-bottom: 20px;
			border: 1px solid #dedede;

			.name {
				position: absolute;
				font-size: 26px;
				font-weight: 600;
				color: white;
				bottom: 98px;
				left: 40px;
			}

			.expertThinkTank_centerItemBottom {
				background: white;
				display: flex;
				align-items: center;

				div {
					font-size: 14px;
				}

				img {
					margin-right: 14px;
				}
			}

			.selfPhoto {
				width: 359px;
			}
		}
	}

	.expertThinkTank_center_head {
		display: flex;
		justify-content: space-between;
		align-items: center;

		div:first-child {
			display: flex;

			div {
				cursor: pointer;
				margin-right: 20px;
				font-size: 14px;
				color: #333;
				padding-bottom: 4px;
				border-bottom: 2px solid transparent;
			}
		}
	}
</style>
